import { normalizeTag } from "./query";

/** Spaces stay in tag names; a new namespace starts the next tag. Quotes protect literal boundaries. */
export function parseRuleTags(text: string, exclude = false) {
  const tokens: { tag: string; exclude: boolean }[] = [];
  let rest = text.trim();
  while (rest) {
    const prefix = /^([+-]?)([a-z][a-z0-9_]*:)/i.exec(rest);
    if (!prefix) throw new Error("태그는 language:korean처럼 분류:이름으로 넣으세요.");
    let end = prefix[0].length;
    let quoted = false;
    for (; end < rest.length; end++) {
      if (rest[end] === '"') quoted = !quoted;
      if (!quoted && /\s/.test(rest[end]!) && /^\s+[+-]?[a-z][a-z0-9_]*:/i.test(rest.slice(end))) break;
    }
    if (quoted) throw new Error("태그 이름의 따옴표를 닫아 주세요.");
    const name = rest.slice(prefix[0].length, end).replace(/"/g, "").trim();
    const tag = normalizeTag(prefix[2] + name);
    if (!name || tag.length > 200) throw new Error("태그 이름을 넣으세요. 태그는 200자까지 가능합니다.");
    tokens.push({ tag, exclude: exclude || prefix[1] === "-" });
    rest = rest.slice(end).trimStart();
  }
  return tokens;
}

export function addRuleTags(
  tags: readonly string[],
  xtags: readonly string[],
  typed: string,
  exclude = false,
) {
  let included = [...tags];
  let excluded = [...xtags];
  for (const item of parseRuleTags(typed, exclude)) {
    included = included.filter((tag) => tag !== item.tag);
    excluded = excluded.filter((tag) => tag !== item.tag);
    (item.exclude ? excluded : included).push(item.tag);
  }
  if (included.length > 50 || excluded.length > 50)
    throw new Error("포함·제외 태그는 각각 50개까지 넣을 수 있습니다.");
  return { tags: included, xtags: excluded };
}
